/* 共享行内 SVG 图标 (lucide 风格, currentColor 描边)
 * 所有图标默认 24x24, fill: none, stroke: currentColor, stroke-width: 1.75 */

const baseProps = {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.75,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
};

export function Layers(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
        </svg>
    );
}

export function Code(props) {
    return (
        <svg {...baseProps} {...props}>
            <polyline points="16 18 22 12 16 6" />
            <polyline points="8 6 2 12 8 18" />
        </svg>
    );
}

export function Merge(props) {
    return (
        <svg {...baseProps} {...props}>
            <circle cx="18" cy="18" r="3" />
            <circle cx="6" cy="6" r="3" />
            <path d="M6 21V9a9 9 0 0 0 9 9" />
        </svg>
    );
}

export function Repeat(props) {
    return (
        <svg {...baseProps} {...props}>
            <polyline points="17 1 21 5 17 9" />
            <path d="M3 11V9a4 4 0 0 1 4-4h14" />
            <polyline points="7 23 3 19 7 15" />
            <path d="M21 13v2a4 4 0 0 1-4 4H3" />
        </svg>
    );
}

export function Rocket(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
            <path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
            <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
            <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
        </svg>
    );
}

export function Database(props) {
    return (
        <svg {...baseProps} {...props}>
            <ellipse cx="12" cy="5" rx="9" ry="3" />
            <path d="M3 5v6c0 1.66 4.03 3 9 3s9-1.34 9-3V5" />
            <path d="M3 11v6c0 1.66 4.03 3 9 3s9-1.34 9-3v-6" />
        </svg>
    );
}

export function Cpu(props) {
    return (
        <svg {...baseProps} {...props}>
            <rect x="4" y="4" width="16" height="16" rx="2" ry="2" />
            <rect x="9" y="9" width="6" height="6" />
            <line x1="9" y1="2" x2="9" y2="4" />
            <line x1="15" y1="2" x2="15" y2="4" />
            <line x1="9" y1="20" x2="9" y2="22" />
            <line x1="15" y1="20" x2="15" y2="22" />
            <line x1="20" y1="9" x2="22" y2="9" />
            <line x1="20" y1="14" x2="22" y2="14" />
            <line x1="2" y1="9" x2="4" y2="9" />
            <line x1="2" y1="14" x2="4" y2="14" />
        </svg>
    );
}

export function Zap(props) {
    return (
        <svg {...baseProps} {...props}>
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
        </svg>
    );
}

export function ShieldCheck(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <polyline points="9 12 11 14 15 10" />
        </svg>
    );
}

export function Atom(props) {
    return (
        <svg {...baseProps} {...props}>
            <circle cx="12" cy="12" r="1.5" />
            <ellipse cx="12" cy="12" rx="10" ry="4" />
            <ellipse cx="12" cy="12" rx="10" ry="4" transform="rotate(60 12 12)" />
            <ellipse cx="12" cy="12" rx="10" ry="4" transform="rotate(120 12 12)" />
        </svg>
    );
}

export function Layout(props) {
    return (
        <svg {...baseProps} {...props}>
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <line x1="3" y1="9" x2="21" y2="9" />
            <line x1="9" y1="21" x2="9" y2="9" />
        </svg>
    );
}

export function Download(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    );
}

export function Globe(props) {
    return (
        <svg {...baseProps} {...props}>
            <circle cx="12" cy="12" r="10" />
            <line x1="2" y1="12" x2="22" y2="12" />
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
    );
}

export function Sparkles(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z" />
            <path d="M19 14l.8 2.4L22 17l-2.2.6L19 20l-.8-2.4L16 17l2.2-.6L19 14z" />
            <path d="M5 14l.8 2.4L8 17l-2.2.6L5 20l-.8-2.4L2 17l2.2-.6L5 14z" />
        </svg>
    );
}

export function FileText(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="8" y1="13" x2="16" y2="13" />
            <line x1="8" y1="17" x2="14" y2="17" />
            <line x1="8" y1="9" x2="10" y2="9" />
        </svg>
    );
}

export function Users(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
    );
}

export function Link2(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M15 7h3a5 5 0 0 1 0 10h-3" />
            <path d="M9 17H6A5 5 0 0 1 6 7h3" />
            <line x1="8" y1="12" x2="16" y2="12" />
        </svg>
    );
}

export function Menu(props) {
    return (
        <svg {...baseProps} {...props}>
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
    );
}

export function X(props) {
    return (
        <svg {...baseProps} {...props}>
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    );
}

export function Github(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
        </svg>
    );
}

export function Mail(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
        </svg>
    );
}

export function Twitter(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
        </svg>
    );
}

export function ArrowRight(props) {
    return (
        <svg {...baseProps} {...props}>
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
        </svg>
    );
}

export function Home(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2h-4v-7h-6v7H5a2 2 0 0 1-2-2z" />
        </svg>
    );
}

export function Search(props) {
    return (
        <svg {...baseProps} {...props}>
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
    );
}

export const ICON_MAP = {
    layers: Layers,
    code: Code,
    merge: Merge,
    repeat: Repeat,
    rocket: Rocket,
    database: Database,
    cpu: Cpu,
    zap: Zap,
    shield: ShieldCheck,
    atom: Atom,
    layout: Layout,
    download: Download,
    globe: Globe,
    sparkles: Sparkles,
    fileText: FileText,
    users: Users,
    link2: Link2,
    menu: Menu,
    x: X,
    github: Github,
    mail: Mail,
    twitter: Twitter,
    arrowRight: ArrowRight,
    home: Home,
    search: Search,
};

export function Icon({ name, ...props }) {
    const Cmp = ICON_MAP[name];
    if (!Cmp) return null;
    return <Cmp {...props} />;
}

export default Icon;
